import React, { useEffect, MouseEvent } from 'react';
import {
  BrowserRouter as Router, Routes, Route, Navigate,
} from 'react-router-dom';
import posthog from 'posthog-js';

import '@scss/index';
import Home from '@page/home/index';
import Vip from '@page/vip/index';
import Login from '@page/login/index';
import Register from '@page/login/register';
import Forget from '@page/login/forget';
import RegisterSetting from '@/page/login/register-setting';
import Effect from '@page/effect/index';
import EffectPdf from '@page/effect-pdf/index';
import Index from '@page/index/index';
import Overview from '@page/index/overview/index';
import IndustryResearch from '@page/index/industry-research/index';
import HumanIndicator from '@page/index/human-indicator/index';
import HumanDemand from '@page/index/human-demand/index';
import WealfareInsight from '@page/index/wealfare-insight/index';
import TalentFlow from '@page/index/talent-flow/index';
import IndexPdf from '@page/index-pdf';
import Dashboard from '@page/dashboard/index';
import { PosthogApiKey, PosthogApiHost } from '@/config';
import { isOAuthAuthorizationNavigation } from '@lib/oauth-authorization';

interface IProps { }
interface IState { }

const AppRoute = () => {
  useEffect(() => {
    console.log('--- posthog api key --- ', PosthogApiKey);
    console.log('--- posthog api host --- ', PosthogApiHost);
    if (isOAuthAuthorizationNavigation(window.location.search)) return;

    posthog.init(PosthogApiKey, {
      api_host: PosthogApiHost,
      persistence: 'localStorage+cookie',
      autocapture: true,
    });
  }, []);

  return (
    <Router>
      <Routes>
        <Route path="vip" element={<Vip />} />
        <Route path="login" element={<Login />} />
        <Route path="forget" element={<Forget />} />
        <Route path="register" element={<Register />} />
        <Route path="register-setting" element={<RegisterSetting />} />
        <Route path="effect" element={<Effect />} />
        <Route path="effectpdf" element={<EffectPdf />} />
        <Route path="index-pdf" element={<IndexPdf />} />
        <Route path="index" element={<Index />}>
          <Route index={true} element={<Navigate to="/index/industry-research/0" />} />
          <Route path="industry-research/:id" element={<IndustryResearch />} />
          <Route path="human-indicator/:id" element={<HumanIndicator />} />
          <Route path="human-demand/:id" element={<HumanDemand />} />
          <Route path="wealfare-insight/:id" element={<WealfareInsight />} />
          <Route path="talent-flow/:id" element={<TalentFlow />} />
        </Route>
        <Route path="index" element={<Index />} />
        <Route path="dashboard" element={<Dashboard />} />
        {/*  尝试跳转到 / 失败，要么跳转后未刷新，页面空白；要么打开任意页面都跳转  */}
        <Route path="*" element={<Navigate to="/vip" />} />
      </Routes>
    </Router>
  );
};

export default AppRoute;
